module.exports = __webpack_public_path__ + "static/media/tutorial-dashboard-step4.6ae12c51.png";